import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { EnvIcon, LMSIcon, ThreeDIcon, XRIcons } from '../../Static/icons/iconshere';
import { checkUserAllowPermissions } from '../../utils/common';
import { CONTENT_2D, CONTENT_3D, CONTENT_AR, CONTENT_CATEGORY, CONTENT_ENVIRONMENT, CONTENT_XR } from '../../constant/Permissions';

const Sidebar = ({ sideBar, setSideBar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentLocation = useLocation();
  const currentPath = currentLocation.pathname;
  const [permissionList, setPermissionList] = useState([]);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [activeTab, setActiveTab] = useState('xr');

  useEffect(() => {
    setPermissionList(userData?.user?.permissions);
  }, [userData]);

  useEffect(() => {
    if (currentPath.startsWith('/dashboard/xr')) setActiveTab('xr');
    else if (currentPath.startsWith('/dashboard/environments')) setActiveTab('environments');
    else if (currentPath.startsWith('/dashboard/3d')) setActiveTab('assets');
    else if (currentPath.startsWith('/dashboard/2d/lms')) setActiveTab('lms');
    else if (currentPath.startsWith('/categories')) setActiveTab('cate');
    else if (currentPath.startsWith('/ar')) setActiveTab('ar');
  }, [currentPath]);

  return (
    <div className='mainside'>
      <div className={sideBar ? 'sidmenu active' : 'sidmenu'}>
        <div className='mainsidelist'>
          <ul>
            {checkUserAllowPermissions(CONTENT_XR) &&
              <>
                <li className={`${activeTab === 'xr' ? 'active' : ''}`} onClick={() => navigate("/dashboard/xr")}>
                  <XRIcons /><p className='ms-3'>XR Modules</p>
                </li>
              </>
            }

            {
              checkUserAllowPermissions(CONTENT_3D) &&
              <li onClick={() => navigate(`/dashboard/3d/${configData.config["3dAssetsId"]}`)} className={`${activeTab === 'assets' ? 'active' : ''}`}>
                <ThreeDIcon /><p className='ms-3'>3D Assets</p>
              </li>
            }

            { checkUserAllowPermissions(CONTENT_ENVIRONMENT) &&
              <li onClick={() => navigate("/dashboard/environments")} className={`${activeTab === 'environments' ? 'active' : ''}`}>
                <EnvIcon /><p className='ms-3'>Environments</p>
              </li>
            }

            { checkUserAllowPermissions(CONTENT_2D) &&
              <li onClick={() => navigate("/dashboard/2d/lms")} className={`${activeTab === 'lms' ? 'active' : ''}`}>
                <LMSIcon /><p className='ms-3'>2D LMS</p>
              </li>
            }

            {checkUserAllowPermissions(CONTENT_CATEGORY) && 
             <li onClick={() => navigate(`/categories`)} className={`${activeTab === 'cate' ? 'active' : ''}`}>
              <ThreeDIcon />
              <p className='ms-3'>Categories</p>
            </li>}

            {checkUserAllowPermissions(CONTENT_AR) &&
             <li onClick={() => navigate(`/ar/list`)} className={`${activeTab === 'ar' ? 'active' : ''}`}>
              <ThreeDIcon />
              <p className='ms-3'>AR Content</p>
            </li>}

          </ul>
        </div>
      </div>
    </div>
  )
}

export default Sidebar